import { fetchApi } from "./fetchApi";

export const getFiles = (setFiles) => {
  fetchApi("GET", "/services/plugin-upload/get")
    .then((response) => {
      if (response.ok) {
        let promises = [];
        response.data.forEach((uuid) => {
          promises.push(
            fetchApi("GET", `/services/plugin-upload/info/${uuid}`)
          );
        });

        // return promises
        Promise.all(promises)
          .then((result) => {
            // console.log("result", result)
            setFiles(
               result
                .reduce((prev, cur) => {
                  if (cur.ok) return [...prev, cur.data];
                  return prev;
                }, [])
                .sort((a, b) => Number(b.timestamp) - Number(a.timestamp))
            );
          })
          .catch((err) => console.warn("Fetch error: ", err));
      }
    })
    .catch((err) => console.warn("Fetch error: ", err));
};
